@if (isPhoenix) {
  <amfam-phoenix-payment-confirmation-wrapper />
} @else {
  <div class="confirmation-container">
    <div class="flex">
      <span class="pseudo-icon success"></span>
      <h3 data-cy="confirmationHeading">
        {{ (simplifiedPaymentInfo$ | async).confirmationHeading }}
      </h3>
    </div>
    <p class="subheading">
      <span [innerHTML]="subHeading" data-cy="confirmationParagraphText"></span
      ><span [innerHTML]="userEmail" data-cy="confirmationEmailAddress"></span>
    </p>
    <div>
      @for (account of (simplifiedPaymentInfo$ | async).selectedBillAccounts; track account) {
        <div class="margin-bottom-30" data-cy="confirmationNumOfBillAccounts">
          <div class="flex">
            <p class="margin-right-5" data-cy="youPaidText">You paid:</p>
            <p class="bold" data-cy="confirmationAccountNickName">{{ account.nickName }}</p>
          </div>
          <div class="flex">
            <p
              class="row truncate-string-ellipsis margin-right-5"
              data-cy="confirmationAccountRisk"
            >
              {{ account.risk }}
            </p>
            <p class="amount" data-cy="confirmationAccountAmount">
              {{ account.amount | currencyUSD }}
            </p>
          </div>
        </div>
      }
    </div>

    <div class="flex">
      <p class="margin-right-5" data-cy="confrimationPaymentMethodText">Payment method:</p>
      <p class="bold" data-cy="confrimationPaymentMethodNickName">
        {{ (simplifiedPaymentInfo$ | async).paymentMethodNickName }}
      </p>
    </div>
    <div class="flex">
      <p class="margin-right-5" data-cy="confrimationPaymentDateText">Payment date:</p>
      <p class="bold" data-cy="confrimationPaymentDate">
        {{ (simplifiedPaymentInfo$ | async).paymentDate }}
      </p>
    </div>

    <div class="total">
      <a (click)="print()">
        <span class="icon-print" data-cy="confirmationPrintIcon"></span>
        <span data-cy="confirmationPrintLink">Print</span>
      </a>
      <p class="total-text" data-cy="confirmationTotalText">Total:</p>
      <p class="total-amount" data-cy="confirmationTotalAmount">
        {{ (simplifiedPaymentInfo$ | async).totalAmount | currencyUSD }}
      </p>
    </div>
    <div [innerHtml]="disclaimer$ | async" data-cy="confirmationDisclaimer"></div>
  </div>

  <div class="sticky-container">
    <call-to-action
      [primaryButtonName]="primaryButtonName"
      [secondaryButtonName]="secondaryButtonName"
      (primaryEvent)="primaryEvent()"
      (secondaryEvent)="secondaryEvent()"
    ></call-to-action>
  </div>
}
